import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bc87746"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ModalFundFlowContent" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "agree" }
const _hoisted_4 = { class: "text-rt footer" }

import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import ModalConfirmReceipt from '@/views/setup/components/ModalConfirmReceipt.vue'
import { ElMessage } from 'element-plus'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { GetUserConfigResProps, ASK_ENUM } from '@/views/setup/components/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const [_, setUserConfig] = useUserConfig(ENUM_CONFIG_CODE.RETAIL_BOOK)
const store = useStore()
/** 当前用户店铺列表 */
const shops = computed(() => store.getters.userShops)
/** 当前用户的店铺 */
const currentStoreId = computed(() => store.getters.curShop)

/** 当前的下载的名字 */
const currentStoreName = computed(() => {
  const findIndex = shops.value.findIndex((item: any) => String(item.customerShopId) === String(currentStoreId.value))
  if (findIndex !== -1) {
    return shops.value[findIndex].customerShopName + '様'
  }
  return ''
})

/** 是否展示modal */
const visible = ref(false)
/** 是否同意 0-不同意 1-同意 */
const isAgree = ref(ASK_ENUM.ASK)
/** 是否同意协议 */
const agreeProtocol = ref(false)
/** 领授书抬头输入的内容 */
const receiptInputContent = ref('')
/** 父级传过来的回调函数 */
const gobackFunc = ref<(value: string) => void>()

const modalConfirmReceiptRef = ref<InstanceType<typeof ModalConfirmReceipt>>()

const cancel = () => {
  visible.value = false
}

const ok = async () => {
  if (typeof receiptInputContent.value !== 'string' || receiptInputContent.value.trim().length === 0) {
    ElMessage.error(t('请输入内容'))
    return
  }
  const requestData: GetUserConfigResProps = {
    askEveryTime: isAgree.value,
    content: receiptInputContent.value
  }
  const res = await setUserConfig(JSON.stringify(requestData))
  // 需要设置到接口里
  gobackFunc.value?.(receiptInputContent.value)
  visible.value = false
}

const open = (inputValue: string, func: (value: string) => void) => {
  // 获取当前下载的名字
  receiptInputContent.value = inputValue || currentStoreName.value
  visible.value = true
  gobackFunc.value = func
}

const handleAgree = () => {
  isAgree.value = isAgree.value === ASK_ENUM.ASK ? ASK_ENUM.NO_ASK : ASK_ENUM.ASK
}

const protocolBack = (protocolStatus: boolean) => {
  agreeProtocol.value = protocolStatus
}

const openDesc = () => {
  modalConfirmReceiptRef.value?.open()
}
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CommonDialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      "show-close": false,
      width: 480,
      className: "ModalFundFlowContentWrap",
      onOk: ok,
      onCancel: cancel,
      title: _unref(t)('请输入领授书抬头'),
      footer: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('领授书抬头')), 1),
          _createVNode(_component_el_input, {
            class: "receipt-input",
            modelValue: receiptInputContent.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((receiptInputContent).value = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_checkbox, {
              modelValue: isAgree.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isAgree).value = $event)),
              "true-label": _unref(ASK_ENUM).NO_ASK,
              "false-label": _unref(ASK_ENUM).ASK
            }, null, 8, ["modelValue", "true-label", "false-label"]),
            _createElementVNode("div", { onClick: handleAgree }, _toDisplayString(_unref(t)('口每次下载都使用该抬头，下次不再询问。')), 1)
          ]),
          _createElementVNode("div", {
            onClick: openDesc,
            class: "blue"
          }, _toDisplayString(_unref(t)('免责声明')) + "> ", 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              class: "footer-btn",
              onClick: cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "footer-btn",
              type: "primary",
              onClick: ok
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('同意免责声明并保存')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(ModalConfirmReceipt, {
      onOk: protocolBack,
      ref: (_value, _refs) => {
        _refs['modalConfirmReceiptRef'] = _value
        modalConfirmReceiptRef.value = _value
      }
    }, null, 512)
  ]))
}
}

})